import { useMutation } from 'react-query'
import { putAPI } from 'framework/api/http'

interface UpdateWarehouseIntegrationInterface {
  apiKey?: string
  baseUrl?: string
  clientId?: string
  clientSecret?: string
  clientSecretGeneratedAtUtc?: string
  id?: string
  name?: string
  token?: string
  warehouseId?: string
}

export const useUpdateWarehouseIntegration = () => {
  const mutate = useMutation(
    ({
      baseUrl,
      apiKey,
      clientId,
      clientSecret,
      clientSecretGeneratedAtUtc,
      id,
      name,
      token,
      warehouseId,
    }: UpdateWarehouseIntegrationInterface) => {
      return putAPI(`/Warehouse/${warehouseId}/Integration/${name}/${id}`, {
        baseUrl,
        apiKey: name === 'IcsWMS' ? apiKey : undefined,
        token: name === 'PaperlessWMS' ? token : undefined,
        /**
         * BDA (B-Connect) only. clientSecret is sent ONLY when the user typed a new one —
         * the GET never returns the stored secret, so an empty value must be omitted or the
         * API would re-encrypt an empty string and break authentication.
         */
        clientId: name === 'BDA' ? clientId : undefined,
        clientSecret: name === 'BDA' && clientSecret ? clientSecret : undefined,
        clientSecretGeneratedAtUtc:
          name === 'BDA' ? clientSecretGeneratedAtUtc : undefined,
      })
    },
  )

  return mutate
}

export default useUpdateWarehouseIntegration
